<template>
  <div>
    <BModal
      :value="value"
      title="Ny Social Kanal"
      @input="$emit('input', $event)"
      @hide="$helpers.ClearForm(form)"
    >
      <div slot="body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <BForm :elements="form" @valid="form.valid = $event"></BForm>
          </div>
          <div class="column is-12">
            <ImageUploader
              ref="imageUploader"
              class="margin-bottom-30"
              path="upload/card/image"
              css="is-primary"
              btnName="Välj bild"
              format="is-32x32"
              :hideSave="true"
            >
              <h1>Lägg till bild</h1>
              <p>Dra och släpp bilder i denna rutan, eller</p>
            </ImageUploader>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="button is-success"
          :disabled="
            isLoading || !form.valid || $refs.imageUploader.images.length == 0
          "
          :class="{ 'is-loading': isLoading }"
          @click="Save()"
        >
          Spara
        </button>
        <button
          class="button"
          @click="
            $emit('input', false);
            $helpers.ClearForm(form);
          "
        >
          Cancel
        </button>
      </div>
    </BModal>
  </div>
</template>

<script>
import BForm from "@/components/singles/BForm/component.vue";
import ImageUploader from "@/components/singles/ImageUploader.vue";
import BModal from "@/components/singles/BModal/component.vue";

export default {
  components: { BForm, ImageUploader, BModal },
  props: ["value"],
  data() {
    return {
      showModal: false,
      ready: false,
      isLoading: false,
      form: {
        valid: false,
        inputs: [
          {
            icon: "fa-link",
            name: "address",
            placeholder: "Länkadress",
            type: "text",
            label: null,
            validation: {
              required: true,
              regex: /^(https:\/\/|http:\/\/)(.)+$/
            },
            value: "",
            focus: true
          }
        ]
      }
    };
  },
  methods: {
    async Save() {
      this.isLoading = true;
      let toSend = {
        pageName: "all",
        uid: "",
        object: {
          address: this.form.inputs[0].value,
          active: true
        }
      };

      let result = await this.$helpers.PostApi("set/pageCard", toSend);
      let images = await this.$refs.imageUploader.Save(result[0].uid);

      this.$helpers.ClearForm(this.form);
      this.form.valid = false;
      this.$helpers.ShowStatus("Sparad.", 3000);
      this.isLoading = false;
      this.$emit("saved", { card: result[0], images: images });
      this.$emit("input", false);
    }
  }
};
</script>
